// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"index-module--sidebar--VnmvG","sidebar__inner":"index-module--sidebar__inner--hUSPm"};